import { Component, OnInit } from '@angular/core';
import { PlanService } from 'src/services/plan/plan.service';
import { Plan } from 'src/classes/plan';
import { KPIService, KPIReturn } from 'src/services/kpi/kpi.service';

@Component({
  selector: 'app-edit-plan-details-page',
  templateUrl: './edit-plan-details-page.component.html',
  styleUrls: ['./edit-plan-details-page.component.scss']
})
export class EditPlanDetailsPageComponent implements OnInit {

  public isLoading = true;
  public plans: Plan[] = [];
  public selectedPlan: number;
  public activePlan: number;

  constructor(
    private planService: PlanService,
    private kpiService: KPIService,
  ) { }

  ngOnInit() {
    this.isLoading = true;

    Promise.all([
      this.fetchAvailablePlans(),
      this.kpiService.getKPIs()
    ]).then(this.onFinishLoading.bind(this));
  }

  onFinishLoading([plans, kpi]: [Plan[], KPIReturn]) {
    // Filter and sort plans
    console.log(plans);
    this.plans = plans.filter(
      plan => plan.show ||plan.id==this.selectedPlan
    ).sort(
      (a, b) => a.priceBRL === null ? 1 : (b.priceBRL === null ? -1 : a.priceBRL - b.priceBRL)
    );

    // Get user current plan
    if (kpi && kpi.plan && typeof kpi.plan.name === "string") {
      for (let i = 0; i < this.plans.length; i++) {
        if (this.plans[i].name === kpi.plan.name) {
          this.selectedPlan = i;
          this.activePlan = i;
          break;
        }
      }
    }

    this.isLoading = false;
  }

  async fetchAvailablePlans() {
    return await this.planService.listPlans();
  }

  onPlanSelect(plan: Plan, index: number) {
    this.selectedPlan = index;
  }

}
